import { useState } from 'react';
import { t } from '@exam-prep/i18n';
import type { Result as ResultData } from '../../../lib/api-types';
import { rankCard, shareCard } from '../model/share-card';

/** Make and share the result image; the button shows busy and failed states. */
export function useShareCard(data: ResultData | null) {
  const [cardState, setCardState] = useState<'idle' | 'busy' | 'done' | 'failed'>('idle');
  const share = async () => {
    if (!data) return;
    setCardState('busy');
    try {
      const blob = await rankCard(data, {
        brand: t('miniapp.card.brand'),
        cta: t('miniapp.card.cta'),
      });
      await shareCard(blob, 'my-mock-result.png');
      setCardState('done');
    } catch {
      setCardState('failed');
    }
  };
  return { cardState, share };
}
